import React, { useEffect } from 'react';

// Pendo API Key: 9ae2a857-3525-4aa8-7888-f959355b6117
const pendoScript = `(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
})('9ae2a857-3525-4aa8-7888-f959355b6117');`;

export const pendoVisitorFromAmplifyUser = (cognitoUser, XEA_Version, local_id = null) => {
  const xeaVersion = XEA_Version ? {XEA_Version} : {};
  const localId = local_id ? {local_id} : {};
  return cognitoUser ? {
    id: cognitoUser?.username || cognitoUser?.id,
    email: cognitoUser?.attributes?.email || cognitoUser?.email,
    XEA_customer_first_name: cognitoUser?.attributes?.['custom:firstName'] || cognitoUser?.XEA_customer_first_name,
    XEA_customer_last_name: cognitoUser?.attributes?.['custom:lastName'] || cognitoUser?.XEA_customer_last_name,
    XEA_job_title: cognitoUser?.attributes?.['custom:jobTitle'] || cognitoUser?.XEA_job_title,
    XEA_marketing_opt_in: cognitoUser?.attributes?.['custom:marketingOptIn'] === 'TRUE' || cognitoUser?.XEA_marketing_opt_in,
    XEA_business_name: cognitoUser?.attributes?.['custom:businessName'] || cognitoUser?.XEA_business_name,
    XEA_pendo_disabled: cognitoUser?.attributes?.['custom:pendoDisabled'] === 'TRUE' || cognitoUser?.XEA_pendo_disabled,
    product: 'XEA',
    ...xeaVersion,
    ...localId,
  } : null;
};

const Pendo = ({amplifyUser, version, localId = null, forcePendoUpdate = null}) => {
  useEffect(() => {
    const addPendoSnippet = () => {
      const el = document.createElement('script');
      el.id = 'pendo-snippet';
      el.innerHTML = pendoScript;
      document.body.appendChild(el);
    };
    if (document.querySelector('#pendo-snippet') === null) {
      addPendoSnippet();
    }
  }, []);

  useEffect(() => {
    const setUser = () => {
      if (window?.pendo) {
        const pendoVisitor = pendoVisitorFromAmplifyUser(amplifyUser, version, localId);
        // We need to check if it's NOT true to make sure the default (false) is used if the user has not set it
        const pendoDisabled = ((forcePendoUpdate !== null && forcePendoUpdate) || amplifyUser?.XEA_pendo_disabled || (amplifyUser?.attributes && amplifyUser?.attributes['custom:pendoDisabled'] === 'TRUE'));
        if (pendoVisitor && !pendoDisabled) {
          if (window.pendo?.isReady && window.pendo.isReady()) {
            console.log(`Pendo: identifying visitor:`, pendoVisitor);
            window.pendo.identify({
              visitor: pendoVisitor,
              account: {
                id: pendoVisitor?.id
              }
            });
          } else {
            console.log(`Pendo: initializing with visitor`, pendoVisitor);
            window.pendo.initialize({
              visitor: pendoVisitor,
              account: {
                id: pendoVisitor?.id
              }
            });
          }
        } else if (window.pendo?.clearSession) {
          console.log(`Pendo: clearing session (disabled: ${pendoDisabled})`);
          // In case there is no user logged in we clear the pendo session and let it create an anonymous user
          window.pendo.clearSession();
        } else {
          console.log(`Pendo: not ready or disabled (disabled: ${pendoDisabled})`);
        }
      } else {
        setTimeout(setUser, 1000);
      }
    };

    setUser();
  }, [amplifyUser, forcePendoUpdate]);

  return <></>;
}

export default Pendo;
